<template lang="pug">
  #app
    template(v-if="loaded")
      router-view
      server-alert
</template>

<script>
import ServerAlert from '@/components/common/server-alert/ServerAlert'
export default {
  name: 'app',

  components: {
    ServerAlert
  },

  data: () => ({
    loaded: false
  }),

  async mounted () {
    const { isAuth } = await this.$store.dispatch('account/init')

    if (isAuth) {
      const path = this.$route.path
      if (path === '/app' || path === '/app/') {
        const isClient = this.$store.getters['account/isClient']
        const isConsultant = this.$store.getters['account/isConsultant']

        if (isClient) {
          this.$router.push('/app/companies')
        } else if (isConsultant) {
          this.$router.push('/app/clients')
        } else {
          this.$router.push('/app/activities')
        }
      }

      if (this.$route.path.includes('/farms/')) {
        const clientId = this.$route.params.client_id || this.$route.params.company_id
        if (clientId) {
          await this.$store.dispatch('setClientId', clientId)
        }
      }
    } else {
      this.$router.push('/auth')
    }
    this.loaded = true
  },
  methods: {}

}
</script>

<style lang="scss">
  @import '@/sass/main.scss';
</style>
